// config.js

// const config = {
//   apiBaseUrl: "https://propertycrm.wearedevelopers.website", // Your API base URL
// };

const config = {
  apiBaseUrl: "https://dashboard.balajipropertiesarcade.com", // Your API base URL
};

// const config = {
//   apiBaseUrl: "http://localhost:5000", // Your API base URL
// };

export const AppName = {
  appName: "Property CRM",
};

export default config;
